import * as Sentry from '@sentry/react';
import { useErrorBoundary } from 'react-error-boundary';
import { Navigate, useLocation } from 'react-router';
import { useData } from '../../../contexts/data-context/use-data';
import Loading from '../../../design-system/loading/loading';

export const AccountsRoutesWrapper = () => {
  const { data, isLoading, error } = useData();
  const { showBoundary } = useErrorBoundary();
  const location = useLocation();

  if (isLoading) {
    return <Loading text="Loading accounts..." />;
  }

  if (!data) {
    Sentry.addBreadcrumb({
      category: 'accounts_routes_wrapper',
      message: 'AccountsRoutesWrapper showing error boundary due to missing data',
      level: 'error',
      data: {
        hasError: !!error,
        errorMessage: error?.message || 'undefined',
        errorType: typeof error,
        isLoading,
        dataExists: !!data,
      },
    });

    showBoundary(error || new Error('Data is undefined in AccountsRoutesWrapper component'));

    return null;
  }

  const { accounts } = data;

  if (accounts.length === 0) {
    return <Navigate to={`./open-seapoint-account${location.search}`} />;
  }

  return <Navigate to={`./connected-accounts${location.search}`} />;
};
